<template>
  <div v-if="goster" class="nps-kart fixed z-40 right-3 bottom-3 sm:right-5 sm:bottom-5 w-[calc(100vw-1.5rem)] sm:w-[23rem] rounded-xl shadow-lg border p-4"
    role="dialog" aria-labelledby="npsKartBaslik">
    <div class="flex items-start gap-2">
      <div id="npsKartBaslik" class="flex-1 text-sm font-semibold">
        {{ tesekkur ? 'Teşekkürler!' : "HepyApp'i bir arkadaşınıza ya da iş ortağınıza tavsiye etme olasılığınız nedir?" }}
      </div>
      <Button icon="pi pi-times" text rounded severity="secondary" aria-label="Kapat" class="!-mt-1 !-mr-2 shrink-0" @click="kapat" />
    </div>

    <template v-if="!tesekkur">
      <div class="grid grid-cols-11 gap-1 mt-3" role="radiogroup" aria-label="0 ile 10 arası puan">
        <button v-for="p in 11" :key="p - 1" type="button" role="radio" :aria-checked="puan === p - 1"
          class="nps-puan h-8 rounded-md text-xs font-medium tabular-nums border"
          :class="{ 'nps-puan-secili': puan === p - 1 }" @click="puan = p - 1">{{ p - 1 }}</button>
      </div>
      <div class="flex justify-between text-[11px] nps-soluk mt-1">
        <span>Hiç olası değil</span><span>Kesinlikle</span>
      </div>

      <template v-if="puan !== null">
        <label for="npsYorum" class="block text-xs nps-soluk mt-3 mb-1">
          {{ puan >= 9 ? 'En çok neyi beğeniyorsunuz?' : 'Neyi daha iyi yapabiliriz?' }} <span class="opacity-70">(isteğe bağlı)</span>
        </label>
        <Textarea id="npsYorum" v-model="yorum" rows="2" maxlength="500" class="w-full text-sm" autoResize />
      </template>

      <div class="flex items-center justify-end gap-2 mt-3">
        <Button label="Sonra" text severity="secondary" :disabled="gonderiliyor" @click="gonder(null)" />
        <Button label="Gönder" :disabled="puan === null" :loading="gonderiliyor" @click="gonder(puan)" />
      </div>
    </template>
    <div v-else class="text-xs nps-soluk mt-1">Yanıtınız ürünü geliştirmemize yardımcı olacak.</div>
  </div>
</template>

<script>
import AuthService from "@/services/auth.service";

// IZ-N (ISTATISTIK-VE-IZLEME-PLANI.md V10): panel içi NPS kartı (sağ-alt). Gösterim kararı BE'de
// (GetNpsDurum → Goster: hesap ≥ 30 gün, son yanıt/erteleme ≥ 90 gün, sağlayıcı/demo hariç).
// "Sonra" = SetNpsCevap {Puan:null} (90 gün sessiz); X = yalnız bu oturum için gizle (kayıt yok).
// Konsol (/sistem) ve destek görüntülemesi (şirkete geç) sırasında hiç sorulmaz.
const GECIKME_MS = 15000; // sayfa açılışıyla yarışmasın, kullanıcı biraz çalıştıktan sonra
const OTURUM_ANAHTARI = "npsKartKapatildi";

export default {
  name: "NpsKart",
  data() {
    return { uygun: false, puan: null, yorum: "", gonderiliyor: false, tesekkur: false, zamanlayici: null };
  },
  computed: {
    goster() {
      return this.uygun && !String(this.$route.path || "").toLowerCase().startsWith("/sistem");
    },
  },
  mounted() {
    if (this.oturumdaKapatildiMi() || AuthService.sirketeGecAktifMi()) return;
    this.zamanlayici = setTimeout(this.durumSor, GECIKME_MS);
  },
  beforeUnmount() {
    clearTimeout(this.zamanlayici);
  },
  methods: {
    oturumdaKapatildiMi() {
      try { return sessionStorage.getItem(OTURUM_ANAHTARI) === "1"; } catch (e) { return false; }
    },
    durumSor() {
      this.$Servis("GET", "GetNpsDurum", "")
        .then((res) => {
          // 999/400/403: sessiz — anket kritik değil, kullanıcıya hata gösterilmez.
          if (res.status === 200 && res.data && res.data.Goster === true) this.uygun = true;
        })
        .catch(() => {});
    },
    kapat() {
      try { sessionStorage.setItem(OTURUM_ANAHTARI, "1"); } catch (e) { /* yok say */ }
      this.uygun = false;
    },
    gonder(puan) {
      if (this.gonderiliyor) return;
      this.gonderiliyor = true;
      const yorum = puan === null ? null : ((this.yorum || "").trim() || null);
      this.$Servis("POST", "SetNpsCevap", { Puan: puan, Yorum: yorum })
        .then((res) => {
          if (res.status === 200) {
            if (puan === null) { this.uygun = false; return; }
            this.tesekkur = true;
            setTimeout(() => { this.uygun = false; }, 2500);
          } else if (res.status === 999) {
            this.$toast.add({ severity: "warn", summary: "Uyarı", detail: res.data, life: 4000 });
          } else {
            this.$toast.add({ severity: "error", summary: "Hata", detail: "Yanıtınız kaydedilemedi.", life: 3000 });
          }
        })
        .catch(() => this.$toast.add({ severity: "error", summary: "Hata", detail: "Sunucuya ulaşılamadı.", life: 3000 }))
        .then(() => { this.gonderiliyor = false; });
    },
  },
};
</script>

<style>
/* KT koyu tema: scoped + :global(.dark) yanlış derlendiği için kasıtlı olarak scoped değil, önekli. */
.nps-kart { background: #fff; border-color: #e5e7eb; color: #111827; }
.nps-soluk { color: #6b7280; }
.nps-puan { background: #f9fafb; border-color: #e5e7eb; color: #374151; transition: background-color .12s, border-color .12s; }
.nps-puan:hover { border-color: #fdba74; background: #fff7ed; }
.nps-puan:focus-visible { outline: 2px solid #ed7a18; outline-offset: 1px; }
.nps-puan-secili, .nps-puan-secili:hover { background: #ed7a18; border-color: #ed7a18; color: #fff; }
.dark .nps-kart, .my-app-dark .nps-kart { background: #111827; border-color: #374151; color: #f1f5f9; }
.dark .nps-soluk, .my-app-dark .nps-soluk { color: #94a3b8; }
.dark .nps-puan, .my-app-dark .nps-puan { background: #1f2937; border-color: #374151; color: #e5e7eb; }
.dark .nps-puan:hover, .my-app-dark .nps-puan:hover { background: rgba(237, 122, 24, .15); border-color: #9a3412; }
.dark .nps-puan-secili, .my-app-dark .nps-puan-secili,
.dark .nps-puan-secili:hover, .my-app-dark .nps-puan-secili:hover { background: #ed7a18; border-color: #ed7a18; color: #fff; }
</style>
